import { Media, Organization } from "chq";
import { isRTX } from "app/utils";

const getMontageVideoUrl = (media: Media, organization: Organization): string => {
  if (isRTX(organization.name)) return media.originalHqCompressedUrl || media.shareableUrl;

  return media.shareableUrl;
};

export default getMontageVideoUrl;
